// extracted by mini-css-extract-plugin
export default {"Checkout":"Checkout_Checkout__RXjpR","OrderInfo":"Checkout_OrderInfo__z8UnO"};